export default __webpack_public_path__ + "static/media/clientFourteen.98152997.png";